export default __webpack_public_path__ + "static/media/JOSA CLASS-8_SYLLABUS_2025-26.b3d56e93.pdf";